import { render, staticRenderFns } from "./objection.vue?vue&type=template&id=0936254c&scoped=true&"
import script from "./objection.vue?vue&type=script&lang=js&"
export * from "./objection.vue?vue&type=script&lang=js&"
import style0 from "./objection.vue?vue&type=style&index=0&id=0936254c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0936254c",
  null
  
)

component.options.__file = "objection.vue"
export default component.exports